/* eslint-disable @typescript-eslint/no-redeclare */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Paper,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
  TextField,
  FormHelperText,
} from "@mui/material";
import { useEffect, useLayoutEffect, useState } from "react";
import TicketTable from "../../../../components/ticket-table";
import { usePersistentState } from "../../../../contexts/global-context";
import { GetLocalStorage } from "../../../../utils/local-storage";
import { isEmpty } from "../../../../utils/validator";
import { DELETE, GET, POST } from "../../../../config/https";
import APIS from "../../../../config/api";
import FullScreenLoader from "../../../../components/full-screen-loader";

import SeparateDateTime from "../../../../utils/sparate-time-date";
import GlobalDateFormat from "../../../../utils/global-date-format";
import ValidationError from "../../../../components/validation-error-label";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const EventTicketConfig = ({ wizardKey }: EventTicketConfigProps) => {
  const [state, dispatch]: any = usePersistentState();
  const [stripe, setStripe] = useState(false);
  const [zelle, setZelle] = useState(false);
  const [pay_To_Host, setPay_To_Host] = useState(false);
  const [ticketTypeConfig, setTicketTypeConfig] = useState<
    {
      TicketType: string;
      ShortDesc: string;
      Price: string;
      QuantityAvailable: string;
      SaleStartDateTime: string;
      SaleStartTime: string;
      SaleEndTime: string;
      SaleEndDateTime: string;
      Ordering: string;
      PerOrderLimit: string;
      IsSoldOut: boolean;
      id: number;
      IsDisabled: boolean;
    }[]
  >([
    {
      TicketType: "",
      ShortDesc: "",
      Price: "",
      QuantityAvailable: "",
      SaleStartTime: "",
      SaleStartDateTime: "",
      SaleEndDateTime: "",
      SaleEndTime: "",
      Ordering: "",
      PerOrderLimit: "",
      IsSoldOut: false,
      IsDisabled: false,
      id: 0,
    },
  ]);

  const [isValidation, setIsValidation] = useState(false);
  const [formErrors, setFormErrors] = useState<Record<string, string>>({});
  const [mount, setMount] = useState(false);
   const [payToHostMessage, setPayToHostMessage] = useState("");
  const [error, setError] = useState("");
    const MAX_LENGTH = 3000;

    const handlePayToHostMessage = (e:any) => {
    const value = e.target.value;
    if (value.length <= MAX_LENGTH) {
      setPayToHostMessage(value);
      setError("");
    } else {
      setError("Maximum limit of 3,000 characters reached.");
    }
  };



  useLayoutEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    if (isValidation) {
      validator();
    }
  }, [ticketTypeConfig, isValidation]);

  useEffect(() => {
    if (wizardKey === 2 && state.AddEventType === "AddTicketConfig") {
      setIsValidation(true);
      if (!validator()) {
        dispatch({
          AddEventType: "",
        });
        return;
      }
      AddMethod();
      setMount(false);
    }
  }, [
    state.WizardKey,
    state.AddEventType,
    wizardKey,
    mount,
    state.toggleState,
  ]);

  useEffect(() => {
    if (mount) return;
    setMount(true);
  }, [state, state.AddEventType]);

  useEffect(() => {
    let temp: any = GetLocalStorage("eventTicketConfig");
    if (temp) {
      let finalData = temp?.map((x: any) => {
        function extractTimeFromDate(dateTimeString: any) {
          const timePart = dateTimeString
            ? dateTimeString?.split("T")[1] || null
            : null;

          return timePart;
        }
        const starttimeOnly = extractTimeFromDate(x?.saleStartDate);
        const endTimeOnly = extractTimeFromDate(x?.saleEndDate);
        return {
          ShortDesc: x?.description,
          Price: x?.price,
          QuantityAvailable: x?.quantity,
          SaleEndDateTime: x?.saleEndDate || "",
          SaleEndTime: endTimeOnly || "",
          SaleStartTime: starttimeOnly || "",
          SaleStartDateTime: x?.saleStartDate || "",
          TicketType: x?.ticketType,
          Ordering: x?.ordering,
          PerOrderLimit: x?.perOrderLimit,
          IsSoldOut: x?.isSoldOut,
          IsDisabled: x.isDisabled,
          id: x?.id,
        };
      });
      setTicketTypeConfig(finalData);
    }
  }, [state.WizardKey]);

  useEffect(() => {
    GetEventDetailFetch();
  }, [state.WizardKey]);

  const AddMethod = async () => {
    if (state.FullScreenLoader) {
      return;
    }
    dispatch({ FullScreenLoader: true });

    try {
      let isSuccess = await AddEventTicketConfig();

      if (isSuccess) {
        dispatch({ WizardKey: state.WizardKey + 1, AddEventType: "" });
      }
    } finally {
      dispatch({ FullScreenLoader: false });
    }
  };
  const AddEventTicketConfig = async () => {
    dispatch({ FullScreenLoader: true });
    let tempData: any = localStorage.getItem("eventDetails");
    let eventId: any = JSON.parse(tempData);
    let temp = await Promise.all(
      ticketTypeConfig.map(async (x: any) => {
        let endDate, startDate;

        if (x?.SaleEndDateTime != null && x?.SaleEndTime != null) {
          endDate = await GlobalDateFormat(x.SaleEndDateTime, x.SaleEndTime);
        }

        if (x?.SaleStartDateTime != null && x?.SaleStartTime != null) {
          startDate = await GlobalDateFormat(
            x.SaleStartDateTime,
            x.SaleStartTime
          );
        }

        return {
          id: x?.id,
          eventId: eventId?.id,
          ticketType: x?.TicketType,
          perOrderLimit: x?.PerOrderLimit,
          description: x?.ShortDesc,
          price: x?.Price,
          quantity: x?.QuantityAvailable,
          saleStartDate: startDate,
          saleEndDate: endDate,
          ordering: Number(x?.Ordering) || 0,
          isSoldOut: x?.IsSoldOut,
          isDisabled: x?.IsDisabled,
        };
      })
    );
    let param = {
      eventId: eventId?.id,
      eventTicketConfig: temp,
      isHost: pay_To_Host,
      isZelle: zelle,
      isStripe: stripe,
      HostText :payToHostMessage
    };
    try {
      const res: any = await POST(APIS.Add_Event_TICKET_CONFIG, param);
      if (res?.isSuccess) {
        localStorage.setItem("eventTicketConfig", JSON.stringify(res?.result));
        if (state.FilledSteps[state.FilledSteps.length - 3] < 5) {
          const updatedSteps = state.FilledSteps.includes(3)
            ? [...state.FilledSteps]
            : [...state.FilledSteps, 3];
          dispatch({ FilledSteps: updatedSteps });
        }

        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
    } finally {
      dispatch({ FullScreenLoader: false });
      setIsValidation(false);
    }
  };

  const handleChangeInputTicketConfig = async (
    index: number,
    event: any,
    ticketTypeId?: string,
    name?: any
  ) => {
    let values: any = [...ticketTypeConfig];
    if (ticketTypeId === "IsSoldOut") {
      const updatedIsSoldOut = values[index].IsSoldOut;
      values[index] = { ...values[index], IsSoldOut: updatedIsSoldOut };
      setTicketTypeConfig(values);
      return;
    }
    let date = null;
    let time = null;
    if (name === "SaleStartDateTime" || name === "SaleEndDateTime") {
      var temp = await SeparateDateTime(event?.$d);
      date = temp?.date;
    }
    if (name === "SaleStartTime" || name === "SaleEndTime") {
      var temp = await SeparateDateTime(event?.$d);
      time = temp?.time;
    }

    switch (name) {
      case "TicketType":
        values[index].TicketType = event?.target?.value;
        break;
      case "ShortDesc":
        values[index].ShortDesc = event?.target?.value;
        break;
      case "Price":
        values[index].Price = event?.target?.value;
        break;
      case "QuantityAvailable":
        values[index].QuantityAvailable = event?.target?.value;
        break;
      case "PerOrderLimit":
        values[index].PerOrderLimit = event?.target?.value;
        break;
      case "SaleStartDateTime":
        values[index].SaleStartDateTime = date;
        break;
      case "SaleStartTime":
        values[index].SaleStartTime = time;
        break;
      case "SaleEndTime":
        values[index].SaleEndTime = time;
        break;
      case "SaleEndDateTime":
        values[index].SaleEndDateTime = date;
        break;
      case "Ordering":
        values[index].Ordering = event?.target?.value;
        break;
      case "PrSaleEndDateTimeice":
        values[index].PrSaleEndDateTimeice = event?.target?.value;
        break;
    }
    setTicketTypeConfig(values);
  };
  const handleAddFieldsTicketConfig = () => {
    setTicketTypeConfig([
      ...ticketTypeConfig,
      {
        TicketType: "",
        ShortDesc: "",
        Price: "",
        QuantityAvailable: "",
        SaleStartDateTime: "",
        SaleStartTime: "",
        SaleEndDateTime: "",
        SaleEndTime: "",
        Ordering: "",
        PerOrderLimit: "",
        IsSoldOut: false,
        id: 0,
        IsDisabled: false,
      },
    ]);
  };

  // const handleRemoveFieldsTicketConfig = (index: number) => {
  //   const values = [...ticketTypeConfig];

  //   values[index] = {
  //     ...values[index],
  //     IsDisabled: true,
  //   };
  //   setTicketTypeConfig(values);
  // };

  const handleRemoveFieldsTicketConfig = async (index: number) => {
    let values = [...ticketTypeConfig];
    if (ticketTypeConfig[index]?.id == 0) {
      values.splice(index, 1);
      setTicketTypeConfig(values);
    } else {
      await DELETE(`${APIS.DELETE_CONFIG}/${ticketTypeConfig[index]?.id}`)
        .then((res: any) => {
          if (res?.result) {
            if (index >= 0 && index < values.length) {
              values.splice(index, 1);
              setTicketTypeConfig(values);
            } else {
              console.log("Invalid index");
            }
          } else {
            toast.error(
              "Ticket config can't be deleted because it's already in use"
            );
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    }
  };
  const handleIsSoldOut = (newValue: any) => {};
  const validator = () => {
    const errors: Record<string, string> = {};

    if (!stripe && !zelle && !pay_To_Host) {
      errors.stripe = "Please select at least one payment type ";
    }

    ticketTypeConfig?.forEach((ticketType, index) => {
      const SaleStartDateTime = GlobalDateFormat(
        ticketType.SaleStartDateTime,
        ticketType.SaleStartTime
      );

      const SaleEndDateTime = GlobalDateFormat(
        ticketType.SaleEndDateTime,
        ticketType.SaleEndTime
      );
      if (!ticketType.TicketType) {
        errors[`TicketType-${index}`] = "Ticket Type is required";
      }

      // if (isEmpty(ticketType.SaleStartDateTime)) {
      //   errors[`SaleStartDateTime-${index}`] = "Start Date is required";
      // }
      // if (isEmpty(ticketType.SaleEndDateTime)) {
      //   errors[`SaleEndDateTime-${index}`] = "End Date is required";
      // }
      // if (isEmpty(ticketType.SaleStartTime)) {
      //   errors[`SaleStartTime-${index}`] = "Start Time is required";
      // }
      // if (isEmpty(ticketType.SaleEndTime)) {
      //   errors[`SaleEndTime-${index}`] = "End Time is required";
      // }

      if (!ticketType.Price) {
        errors[`Price-${index}`] = "Price is required";
      } else if (!/^\d+(\.\d{1,2})?$/.test(ticketType.Price)) {
        errors[`Price-${index}`] =
          "Price should be a valid number with up to 2 decimal places";
      }
      if (!ticketType.QuantityAvailable) {
        errors[`QuantityAvailable-${index}`] = "Quantity Available is required";
      } else if (
        !/^\d+$/.test(ticketType.QuantityAvailable) ||
        parseInt(ticketType.QuantityAvailable) <= 0
      ) {
        errors[`QuantityAvailable-${index}`] =
          "Quantity Available should be a positive integer";
      }
      if (
        !isEmpty(ticketType.SaleStartDateTime) &&
        isEmpty(ticketType.SaleStartTime)
      ) {
        errors[`SaleStartTime-${index}`] = "Start Time is required";
      }
      if (!isEmpty(ticketType.SaleEndDateTime) && isEmpty(ticketType.SaleEndTime)) {
        errors[`SaleEndDateTime-${index}`] = "End Time is required";
      }
      if (
        SaleStartDateTime &&
        SaleEndDateTime &&
        SaleStartDateTime > SaleEndDateTime
      ) {
        errors[`SaleEndDateTime-${index}`] =
          "End Date should be greater then Start Date";
      }
      // if (!ticketType.Ordering) {
      //   errors[`Ordering-${index}`] = "Ordering is required";
      // } else if (
      //   !/^\d+$/.test(ticketType.Ordering) ||
      //   parseInt(ticketType.Ordering) <= 0
      // ) {
      //   errors[`Ordering-${index}`] = "Ordering should be a positive integer";
      // }

      if (!ticketType.Ordering) {
      } else if (
        !/^\d+$/.test(ticketType.Ordering) ||
        parseInt(ticketType.Ordering) <= 0
      ) {
        errors[`Ordering-${index}`] = "Ordering should be a positive integer";
      }

      // if (!ticketType.PerOrderLimit) {
      //   errors[`PerOrderLimit-${index}`] = "Per Order Limit is required";
      // } else if (
      //   !/^\d+$/.test(ticketType.PerOrderLimit) ||
      //   parseInt(ticketType.PerOrderLimit) <= 0
      // ) {
      //   errors[`PerOrderLimit-${index}`] =
      //     "Per Order Limit should be a positive integer";
      // }
      if (!ticketType.PerOrderLimit) {
      } else if (
        !/^\d+$/.test(ticketType.PerOrderLimit) ||
        parseInt(ticketType.PerOrderLimit) <= 0
      ) {
        errors[`PerOrderLimit-${index}`] =
          "Per Order Limit should be a positive integer";
      }
    });
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const GetEventDetailFetch = async () => {
    let eventDetails: any = GetLocalStorage("eventDetails");
    await GET(`${APIS.GET_BY_ID_EVENT}?id=${eventDetails?.id}`)
      .then((res: any) => {
        setPay_To_Host(res?.result?.isHost);
        setZelle(res?.result?.isZelle);
        setStripe(res?.result?.isStripe);
        setPayToHostMessage(res?.result?.hostText || "");
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  return (
    <>
      <FullScreenLoader open={state.FullScreenLoader} />
      <TicketTable
        isSoldOut={(newValue) => handleIsSoldOut(newValue)}
        handleChangeInput={(
          index: number,
          event: any,
          ticketTypeId?: string,
          name?: string
        ) => handleChangeInputTicketConfig(index, event, ticketTypeId, name)}
        handleAddFields={() => handleAddFieldsTicketConfig()}
        handleRemoveFields={(index) => {
          handleRemoveFieldsTicketConfig(index);
        }}
        validationError={formErrors}
        data={ticketTypeConfig}
      />
      <Paper
        elevation={3}
        style={{ padding: "16px", width: "100%", marginTop: 20 }}
      >
        <Typography sx={{ marginTop: "10px", fontWeight: "bold" }}>
          Payment Types:
        </Typography>
        <FormGroup
          sx={{
            position: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <FormControlLabel
            control={
              <Checkbox checked={zelle} onChange={(e) => setZelle(!zelle)} />
            }
            label="Zelle "
          />
          <FormControlLabel
            control={
              <Checkbox checked={stripe} onChange={(e) => setStripe(!stripe)} />
            }
            label="Credit/Debit Card"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={pay_To_Host}
                onChange={(e) => setPay_To_Host(!pay_To_Host)}
              />
            }
            label="Pay To Host"
          />
        </FormGroup>
        {pay_To_Host && (
        <div style={{ marginTop: 16 }}>
          <TextField
            label="Enter custom payment instructions or message"
            variant="outlined"
            fullWidth
            multiline
            minRows={4}
            value={payToHostMessage}
            onChange={handlePayToHostMessage}
            placeholder={`Step 1: Initiate a bank transfer to xxxx@company.com.

Step 2: In the payment reference section, please include the Order ID provided above.

We will email your tickets within 24 hours.
If you have any questions, please contact your event organiser or email us at xxxx@company.com.`}
            inputProps={{ maxLength: MAX_LENGTH }}
          />
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <FormHelperText error={!!error}>{error}</FormHelperText>
            <FormHelperText>
              {payToHostMessage.length} / {MAX_LENGTH} characters
            </FormHelperText>
          </div>
        </div>
      )}
        <ValidationError formErrors={formErrors.stripe} />
      </Paper>
    </>
  );
};
export default EventTicketConfig;

interface EventTicketConfigProps {
  wizardKey: any;
}
